
import { formatDateToMMDDYYYY } from 'shared/utils/dates/formatDate';

interface GenerateMichiganW4PDFParams {
	formik: any;
	employeeSignatureFile?: File | null;
	workplaceName: string;
	organizationName: string;
	employeeEmail: string,
}


// Import your existing PDF generation function
import { generateAndDownloadPDF } from "./pdfUtils"; 

export const handleMichiganW4PDFGeneration = async ({
	formik,
	employeeSignatureFile,
	workplaceName,
	organizationName,
	employeeEmail
}: GenerateMichiganW4PDFParams): Promise<void> => {
	try {
		// Step 1: Prepare Text Fields
		const textFields = {
			"1 Full Social Security Number": formik.values?.ssn,
			"2 Date of Birth": formatDateToMMDDYYYY(formik.values?.date_of_birth),
			"3 Name First Middle Initial Last": (formik.values?.first_name || "") + " " + (formik.values?.middle_initial || "") + " " + (formik.values?.last_name || ""),
			"4 Drivers License Number or State ID": formik.values?.drivers_license_number || "",
			"Home Address No Street PO Box or Rural Route": formik.values?.address || "",
			"mmddyyyy": formatDateToMMDDYYYY(new Date()), // Example date
			"City or Town": formik.values?.city || "",
			"State": formik.values?.state || "",
			"ZIP Code": formik.values?.zip_code?.length <= 6 ? String(formik.values.zip_code) : "",
			"Date": formatDateToMMDDYYYY(new Date()),
			"10 Employers Name": (formik?.values?.employer_name || ""),
			"11 Federal Employer Identification Number": String(formik?.values?.employer_ein).length < 10 ? formik?.values?.employer_ein : "",
			"Address": (formik?.values?.employer_business_address || ""),
			"City": (formik?.values?.employer_city || ""),
			"State_2": (formik?.values?.employer_state || ""),
			"ZIP Code_2": (formik?.values?.employer_zip_code || ""),
			"Name of Contact Person": "",
			"Contact Phone Number": "",
			"Enter the number of personal and dependent exemptions":Number(formik.values.personal_exceptions) > 99	? "" : String(formik.values.personal_exceptions ?? ""),
			"Additional amount you want deducted from each pay":   formik?.values?.deduct_amount !== undefined &&
			formik?.values?.deduct_amount !== null &&
			formik?.values?.deduct_amount !== ''
			  ? String(formik?.values?.deduct_amount)
			  : "0",
		};
		formik?.values?.wages_exempt && Object.assign(textFields, { "Explain Wages are exempt from withholding": formik?.values?.wages_exempt_explanation});
		formik?.values?.home_residence_zone && Object.assign(textFields, { "Permanent home domicile is located in the following Renaissance Zone": formik?.values?.home_residence_zone_explanation});
		const checkboxes = []; 
		formik?.values?.tax_not_expected && checkboxes.push("A Michigan income tax liability is not expected this year");
		formik?.values?.wages_exempt && checkboxes.push("b Wages are exempt from withholding");
		formik?.values?.home_residence_zone && checkboxes.push("C  Permanent home domicile is located in the following Renaissance Zone");

		const radioGroupMappings = {};

		Object.assign(radioGroupMappings, {
		"5 Are you a new employee": formik?.values.new_employee ? "Yes" : "No", 
		});

		// Step 4: Prepare Signatures
		const signatures = [];

		if (employeeSignatureFile || formik.values.internal_signature_file) {
			signatures.push(
				{
					file: employeeSignatureFile || (process.env.REACT_APP_URL + formik.values.internal_signature_file),
					position: {'x': 150, 'y':350, 'width': 100, 'height': 23},
					pageNum: 0,
				}
			);
		}
		
		const textOverlays = [];

		// Step 5: Build filename prefix
		const filePrefix = `Michigan_State_W4${formik.values?.last_name}_${formik.values?.first_name}`;
		
		// Step 6: Generate the filled PDF
		await generateAndDownloadPDF(
			"/Michigan_State_W4.pdf",
			textFields,
			{},
			checkboxes,
			filePrefix,
			workplaceName,
			organizationName,
			employeeEmail,
			formik?.values.id,
			signatures,
			textOverlays,
			radioGroupMappings
		);


	} catch (error) {
		console.error("Error generating I-9 PDF:", error);
	}
};